/**
 * The 'SocialMediaApprovedMediaLibrary' permission was removed from all roles.
 * As part of this change, all uses of the searchApproved function have been deprecated
 * Remove this function when the change has been validated
 */

export default {
    searchApproved(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: "/social-covers/search-approved",
                type: 'GET',
                data: params,
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to load snippets.', xhr);
                reject(xhr);
            });
        });
    }
}